/**
 * FontPreview — Shows heading + body font preview with Google Fonts loading.
 */
import { useEffect } from 'react';

export default function FontPreview({ heading, body }) {
  useEffect(() => {
    const families = [];
    if (heading) families.push(`family=${encodeURIComponent(heading)}:wght@400;700`);
    if (body && body !== heading) families.push(`family=${encodeURIComponent(body)}:wght@400`);
    if (families.length === 0) return;
    const href = `https://fonts.googleapis.com/css2?${families.join('&')}&display=swap`;
    // Avoid duplicate links
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }, [heading, body]);

  return (
    <div className="space-y-1.5">
      <div>
        <div style={{ fontFamily: `'${heading}', sans-serif`, fontWeight: 700 }} className="text-base leading-tight">{heading || 'Heading'}</div>
        <div style={{ fontFamily: `'${heading}', sans-serif`, fontWeight: 700 }} className="text-[10px] text-gray-400">Aa Bb Cc Dd Ee Ff Gg</div>
      </div>
      <div>
        <div style={{ fontFamily: `'${body}', sans-serif`, fontWeight: 400 }} className="text-sm text-gray-600">{body || 'Body text'}</div>
        <div style={{ fontFamily: `'${body}', sans-serif`, fontWeight: 400 }} className="text-[10px] text-gray-400">The quick brown fox jumps</div>
      </div>
    </div>
  );
}
